import React from 'react';
import FileSaver from 'file-saver';

import { archiveList } from './data';

import styles from './support_archive.module.css';

const SupportArchive = () => {
  const onDownload = (saveName, fileName, extension) => {
    if (fileName && extension) {
      FileSaver.saveAs(
        process.env.PUBLIC_URL + `/data/${fileName}.${extension}`,
        `${saveName}.${extension}`
      );
    }
  };

  return (
    <div className={styles.container}>
      <ul className={styles.list}>
        {archiveList &&
          archiveList.map((data, index) => {
            const { title, description, file, extension, size } = data;
            return (
              <li key={index} className={styles.row}>
                <div>
                  {title}{' '}
                  <span className={styles.description}>{description}</span>
                </div>
                <div
                  className={styles.donwloadBtn}
                  onClick={() => onDownload(title, file, extension)}
                >
                  <span>다운로드</span>
                  <span className={styles.size}>({size}MB)</span>
                </div>
              </li>
            );
          })}
      </ul>
    </div>
  );
};

export default SupportArchive;
